import _ from 'underscore';
import audienceStatus from '@bingads-webui-static-legacy/schema/audience/status';
import bidTypes from '@bingads-webui-component-legacy/schema/bid/bidType';
import audienceType from '@bingads-webui-component-legacy/schema/audience/audienceType';
import { AssociationTypes } from '@bingads-webui-campaign-legacy/audience-association/model/consts';
import { types as campaignTypes } from '@bingads-webui-campaign-legacy/adgroup-create-advanced/util/campaignType';
import { AudienceAssociationView } from './base-association-view';
import pageContext from '@bingads-webui-static-legacy/page-context';

const DEFAULT_BID_MULTIPLIER = 0;

export class AimAudienceAssociationView extends AudienceAssociationView {
  initialize({
    campaignId = null,
    adGroupId = null,
    isShoppingCampaign = false,
    customizedTemplates = {},
    deps = {},
    isForVNext = false,
    perfMarker = null,
    isAudienceCreationWorkflow = false,
    isFromAudienceDashboard = false,
    campaignSubType = null,
    hideExclusion = false,
    hideAssociationHeader = false,
    biddingScheme,
    campaignSettings,
    isIMARedesignEnabled = false,
    hideCustomSegmentsOption = false,
  }) {
    this.campaignId = campaignId;
    this.adGroupId = adGroupId;

    super.initialize({
      campaignType: campaignTypes.audience,
      campaignSubType,
      associationType: AssociationTypes.Aim,
      refreshOnInitialize: true,
      shouldShowUiBlockOnRender: false,
      customizedTemplates,
      deps,
      isNewUI: isForVNext,
      perfMarker,
      hideExclusion,
      hideAssociationHeader,
      isAudienceCreationWorkflow,
      isFromAudienceDashboard,
      isAIMAudienceAssociationView: true,
      biddingScheme,
      campaignSettings,
      isIMARedesignEnabled,
      hideCustomSegmentsOption,
    });

    // Allow expansion since this will bypass validation
    this.canExpandAssociation = true;
    this.canExpandExclusion = true;
    this.resetSelectionListBox();

    if (isShoppingCampaign) {
      this.doubleListBoxViewModel.setSelectedCategory(audienceType.Product);
    }

    // override bidType to 'TargetAndBid'
    this.doubleListBoxViewModel.selectedBidType(bidTypes.TargetAndBid);
  }

  cleanup() {
    this.remove();
  }

  getAudienceCriterion() {
    const { associationList, exclusionList } = this.getLists();

    const jsonify = (audience, isTargeting) => {
      // Attempt to find the BidMultiplier from an associtation if it was previously saved
      // otherwise use default "0"

      const originalAssociations = _.map(this.doubleListBoxViewModel.originalAssociations,
        (item) => _.defaults({}, item, {
          Criterion: item.AudienceCriterion,
        }),
      );

      const association = _.find(originalAssociations,
        (item) => audience.Id === item.Criterion.AudienceId);

      let bidMultiplier = _.chain(association)
        .result('Criterion')
        .result('BidMultiplier', DEFAULT_BID_MULTIPLIER)
        .value();

      const cashbackPercent = _.chain(association)
        .result('Criterion')
        .result('CashbackAdjustment')
        .value();

      let associationId = _.result(association, 'Id', null);

      // We only assume the status based on which list it was stored in
      let status = isTargeting ? audienceStatus.Active : audienceStatus.Excluded;

      // If audience is in the targeting list and was originally associated as "Paused"
      // then we should use the "Paused" value as this component doesn't allow changing from
      // "Active" to "Paused" or vice versa.
      if (isTargeting &&
        _.result(association, 'Status') === audienceStatus.Paused
      ) {
        status = audienceStatus.Paused;
      }

      const result = {
        BidType: this.doubleListBoxViewModel.selectedBidType(),
        Status: status,
        Id: associationId,
        Criterion: {
          AudienceId: audience.Id,
          AudienceName: audience.Name,
          AudienceType: audience.Type,
          BidMultiplier: bidMultiplier,
          Type: 'Audience',
        },
      };

      if (pageContext.Permissions.IsPersonalizedOffersEnabled) {
        result.Criterion.CashbackPercent = cashbackPercent;
      }

      return result;
    };

    return _.union(
      _.map(associationList, (item) => jsonify(item, true)),
      _.map(exclusionList, (item) => jsonify(item, false)),
    );
  }

  updateContext(campaignId, adGroupId) {
    this.campaignId = parseInt(campaignId);
    this.adGroupId = parseInt(adGroupId);
  }

  getSelectedEntity() {
    return {
      selectedAdgroupId: this.adGroupId,
      selectedCampaignId: this.campaignId,
      selectedAdgroupName: null,
      selectedCampaignName: null,
    };
  }
}
